import request from './interceptor'
// let url = "http://wlkf.natapp1.cc"; // 后台本地环境
// let url = "http://192.168.1.22:8082"; // 后台本地环境
// let url = "http://47.103.36.64:8085"; //测试环境
let url = "http://api.ahsjgs.com"; // 正式环境

// 文件上传
export function fileUpload(params) {
  return request.post(url + '/v1/sys/fileUpload', params)
}

// 查询栏目列表
export function commonMenuList() {
  return request.get(url + '/common/menu/list')
}

// 查询子级栏目
export function menuDetail(params) {
  return request.get(url + '/common/menu/detail', {params})
}

// 查询宣传横幅列表
export function bannerList(params) {
  return request.get(url + '/v1/wb/banner/list', {params})
}

// 查询新闻列表
export function contentList(params) {
  return request.get(url + '/v1/wb/content/list', {params})
}

// 获取新闻详情
export function contentDetail(params) {
  return request.get(url + '/v1/wb/content/detail', {params})
}

// 查询新闻搜索 未使用
export function contentSearch(params) {
  return request.get(url + '/v1/wb/content/search', {params})
}

// 查询新闻列表(关于我们 企业文化 科技创新 业务领域)
export function enterpriseList(params) {
  return request.get(url + '/v1/wb/enterprise_content/list', {params})
}

// 添加招聘人员
export function recruit(params) {
  return request.post(url + '/v1/wb/recruit', params)
}

// 职位详情
export function recruitDetail(params) {
  return request.get(url + '/v1/wb/recruit/detail', {params})
}

// 查询招聘类目
export function recruitItems(params) {
  return request.get(url + '/v1/wb/recruit/item', {params})
}

// 职位搜索
export function recruitSearch(params) {
  return request.get(url + '/v1/wb/recruit/search', {params})
}
// 工程案例
export function engineerList(params) {
  return request.get(url + '/v1/wb/content/engineer/list', {params})
}
//查询字典 1房建下子级栏目
export function commonItems(params) {
  return request.get(url + '/common/items', {params})
}
export function getCaseDetail(params){
  return request.get(url+'/v1/wb/content/engineer/detail',{params}) 
}
//分享
export function getSignature(params) {
  return request.get(url + '/v1/wb/getSignature', {params})
}
